import type { UseQueryResult } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import { createContractReadinessHook } from "./contract-readiness-query"
import type { SolarContractReadinessDto } from "../dto/solar-contract.dto"
import { solarProposalService } from "../services/solar-proposal.service"

const useReadiness = createContractReadinessHook<SolarContractReadinessDto>({
  queryKey: queryKeys.solarProposal.contract,
  fetchReadiness: (proposalId) =>
    solarProposalService.getContractReadiness(proposalId),
  missingIdMessage: `Solar Proposal id is required`,
})

/**
 * Server-derived Solar contract readiness, fetched while the Contract drawer
 * is open and polled while a send is reconciling. Every Solar price- or
 * savings-dependent command invalidates it.
 */
export default function useSolarContractReadiness(
  proposalId: string | undefined,
): UseQueryResult<SolarContractReadinessDto> {
  return useReadiness(proposalId)
}
